import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { mediaQuery } from 'src/themes/breakpoints';

const GridWrapper = styled.div<GridProps>`
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 40px;

  ${({ columns }) =>
    css`
      grid-template-columns: repeat(${columns - 3}, 1fr);

      ${mediaQuery('sm')} {
        grid-template-columns: repeat(${columns - 2}, 1fr);
      }

      ${mediaQuery('md')} {
        grid-template-columns: repeat(${columns - 1}, 1fr);
      }

      ${mediaQuery('lg')} {
        grid-template-columns: repeat(${columns}, 1fr);
      }
    `}
`;

interface GridProps {
  columns: number;
  children: React.ReactNode;
}

const Grid: FC<GridProps> = ({ columns, children }) => {
  return <GridWrapper columns={columns}>{children}</GridWrapper>;
};

export default Grid;
